import io from 'socket.io-client';
import { NotifyPayload } from 'models/Notify/type';
import { NotifyActionType } from 'models/Notify/enum';

export class NotifyDomain {
  private static instance: NotifyDomain;
  private readonly socket: SocketIOClient.Socket;
  private readonly server =
    process.env.NODE_ENV === 'production'
      ? process.env.NOTIFY_SERVER || 'https://notify.deploygate.com:443'
      : process.env.NOTIFY_SERVER || 'https://notify.staging.dgtest.info:443';

  constructor() {
    this.socket = io(this.server, { transports: ['websocket', 'polling'] });
  }

  static getInstance(): NotifyDomain {
    if (!NotifyDomain.instance) {
      NotifyDomain.instance = new NotifyDomain();
    }
    return NotifyDomain.instance;
  }

  subscribeDownloadIpa(token?: string): Promise<void> {
    const action = NotifyActionType.downloadIpa;
    if (!token) return Promise.reject();

    return this.subscribeOnce(action, token);
  }

  subscribeDistributionLeave(func: () => void, token?: string): void {
    const action = NotifyActionType.distributionLeave;
    if (!token) return;

    // 同じtokenとactionに紐づくリスナーを再度subscribeしないようにする
    if (this.socket.hasListeners(`${token}:${action}`)) {
      return;
    } else {
      this.socket.on(`${token}:${action}`, () => ({}));
    }

    this.subscribeOn(func, action, token);
  }

  subscribeOnce(action: NotifyActionType, token: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this.socket.emit('subscribe', token, action);
      this.socket.once(token, (payload: NotifyPayload) => {
        if (payload.action === action) {
          resolve();
        } else {
          reject();
        }
      });
    });
  }

  subscribeOn(func: () => void, action: NotifyActionType, token: string): void {
    this.socket.emit('subscribe', token, action);
    this.socket.on(token, (payload: NotifyPayload) => {
      if (payload.action === action) func();
    });
  }
}
